import { render, staticRenderFns } from "./Regionsmasonry.vue?vue&type=template&id=2c97edb1&scoped=true&"
import script from "./Regionsmasonry.vue?vue&type=script&lang=js&"
export * from "./Regionsmasonry.vue?vue&type=script&lang=js&"
import style0 from "./Regionsmasonry.vue?vue&type=style&index=0&id=2c97edb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c97edb1",
  null
  
)

export default component.exports